import React from 'react';
import PropTypes from "prop-types";
import { I18n } from "react-redux-i18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SimpleField from "../../../../../shared/components/fields/simpleField/SimpleField";
import WidgetOptions from "../WidgetOptions";
import { Scrollbars } from "react-custom-scrollbars";
import { interfaceDataTypes } from './../../../../../interfaces/utils/InterfaceUtils';

const ControllerWidget = ({
    widgetId = "",
    widgetDisplayName = "",

    interfaceName = "- - -",
    value = "- - -",
    valueDescription = null,
    lastUpdateTimestamp = "---",
    interfaceUnitType = "",
    dataType = null,

    showTemporaryIcon = false,
    widgetOnEditMode = false,

    onFieldChange = () => { },
    onEditValueClicked = () => { },
    onControllerSubmitClicked = () => { },
    onControllerButtonToggled = () => { },
    onCancelClicked = () => { },

    isEditMode = false,
    isDashboardFullScreen = false,

    onForceUpdateClick = () => { },
    onEditClick = () => { },
    onDuplicateClicked = () => { },
    onDeleteClicked = () => { },
    widgetHasError = false
}) => {
    const temporaryIcon = showTemporaryIcon &&
        <div 
            data-for='widget_option' 
            data-tip={I18n.t("dashboard.alerts.widget.controllerWidget.waitingResponse")} 
            className="controller-temporary-icon" 
            style={{ cursor: "pointer", display: "block", zIndex: 2 }}
        >
            <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} />
        </div>;

    let actionArea, editArea;

    if (dataType !== interfaceDataTypes.BOOLEAN) {
        actionArea = (
            <div className="controller-value-area controller-element controller-element-3">
                <SimpleField
                    disabled={!widgetOnEditMode}
                    value={value}
                    fieldStyle={{ marginTop: "8px", marginLeft: "0" }}
                    enabledClassName="simple-field simple-field-edit"
                    disabledClassName="simple-field"
                    onFieldChange={onFieldChange}
                    onEnterPressed={onControllerSubmitClicked}
                />
                <label style={{ marginTop: "8px", width: "30%", textAlign: "left", fontWeight: "normal" }}>{interfaceUnitType}</label>
            </div>
        );

        if(!widgetHasError) {
            if(!widgetOnEditMode) {
                editArea = (
                    <div className="controller-element controller-element-2 controller-edit c-white display-center" onClick={onEditValueClicked}>
                        <FontAwesomeIcon icon={['fas', 'pen']} />
                    </div>
                );
            } else if(widgetOnEditMode) {
                editArea = (
                    <div className="controller-container controller-element-2 controller-edit">
                        <div className="controller-element controller-element-1 controller-edit-cancel display-center" onClick={onCancelClicked}>
                            <FontAwesomeIcon icon={['fas', 'times']} />
                        </div>
                        <div className="controller-element controller-element-1 controller-edit-confirm display-center" onClick={onControllerSubmitClicked}>
                            <FontAwesomeIcon icon={['fas', 'check']} />
                        </div>
                    </div>
                );
            }
        }
    } else {
        actionArea = (
            <div className="controller-element controller-element-3">
                <SimpleField
                    disabled={!widgetOnEditMode}
                    value={value? 'On' : 'Off'}
                    fieldStyle={{ margin: "0", padding: '0', marginTop: "38px", width: "100%", textAlign: "center" }}
                    disabledClassName="simple-field"
                />
            </div>
        );

        if(!widgetHasError) {
            editArea = (
                <div className="controller-element controller-element-2 " style={{ lineHeight: 3 }}>
                    <label className="switch" style={{ verticalAlign: "text-bottom" }}>
                        <input type="checkbox" checked={value} onChange={e => onControllerButtonToggled(e.target.checked)} />
                        <span className="slider round" />
                    </label>
                </div>);
        }
    }

    let inputBg = "";
    if (dataType !== interfaceDataTypes.BOOLEAN) {
        inputBg = " controller-input-bg controller-input-fg";
    } else if (value) {
        inputBg = " controller-input-switch-active-bg";
    } else {
        inputBg = " controller-input-switch-inactive-bg";
    }

    return (
        <div className="widget">
            <div className="row" style={{ height: "100%" }}>
                <div className="controller-container col-lg-12">
                    <div className={"controller-vertical-container controller-value-area controller-element-1 " + inputBg}>
                        {temporaryIcon}
                        {actionArea}
                        {editArea}
                    </div>
                    <div className="controller-element-2 controller-secondary-area">
                        <WidgetOptions
                            widgetHasError={widgetHasError}
                            isEditMode={isEditMode}
                            isDashboardFullScreen={isDashboardFullScreen}
                            showRefreshIcon={true}
                            className="widget-options-contained widget-options-effect"
                            onEditClicked={onEditClick}
                            onRefreshClicked={onForceUpdateClick}
                            onDuplicateClicked={onDuplicateClicked}
                            onDeleteClicked={onDeleteClicked}
                        />
                        <div className={"controller-container controller-info-area"}>
                            <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={1000} style={{ height: "100%" }}>
                                <div className="controller-vertical-container controller-element-3">
                                    <span className="controller-element controller-text-align controller-element-2 wordBreak m-r-25" style={{ fontSize: '13px' }}>{interfaceName}</span>
                                    <span className="controller-element controller-text-align controller-element-3 wordBreak m-r-25" style={{ fontSize: '16px' }}><b>{widgetDisplayName}</b></span>
                                    <span className="controller-element controller-text-align controller-element-1 m-r-25" style={{ fontSize: '12px', paddingBottom: '10px' }}>{lastUpdateTimestamp}</span>
                                </div>
                            </Scrollbars>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

ControllerWidget.propTypes = {
    widgetHasError: PropTypes.bool,
    widgetId: PropTypes.string,
    widgetDisplayName: PropTypes.string,
    value: PropTypes.any,
    timestamp: PropTypes.string,
    unitTypeSymbol: PropTypes.string,
    fontColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    isEditMode: PropTypes.bool,
    isDashboardFullScreen: PropTypes.bool,
    onRefreshClicked: PropTypes.func,
    onForceUpdateClick: PropTypes.func,
    onEditClick: PropTypes.func,
    onDuplicateClicked: PropTypes.func,
    showTemporaryIcon: PropTypes.bool,
    interfaceUnitType: PropTypes.string,
    dataType: PropTypes.string,
    valueDescription: PropTypes.string,
    onFieldChange: PropTypes.func,
    hasPermission: PropTypes.bool,
    onSubmitClicked: PropTypes.func,
    onCancelClicked: PropTypes.func,
    toggleInterfaceActionOfComponent: PropTypes.func,
    onEditValueClicked: PropTypes.func,
};

export default ControllerWidget;